// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SearchWorkflowsResponseModel {
    static getAttributeTypeMap() {
        return SearchWorkflowsResponseModel.attributeTypeMap;
    }
}
SearchWorkflowsResponseModel.discriminator = undefined;
SearchWorkflowsResponseModel.additionalProperties = false;
SearchWorkflowsResponseModel.attributeTypeMap = [
    {
        "name": "workflow",
        "baseName": "workflow",
        "type": "CaseWorkflowModel"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "PatientModel"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": ""
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": ""
    },
];
//# sourceMappingURL=searchWorkflowsResponseModel.js.map